import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class MentoringReportsGridPostParams extends GridPostParams {
    region_search: string = '';
    batch_search: string = '';
    branch_search: string = '';
    state_search: string = '';
    gender_search: string = '';
    status_search: string = '';
    year_search: string = '';
    quarter_search: string = '';
    upload_search: string = ''; // 1- uploaded doc , 2- not uploaded doc
    search_keyword:any = '';
}